import React from 'react';

export const Field = ({ label, required, children, hint }) => (
  <label className="block">
    <span className="block text-sm font-medium text-pvs-text-muted mb-2">
      {label}
      {required && <span className="text-red-400"> *</span>}
    </span>
    {children}
    {hint && <span className="block text-xs text-pvs-text-dim mt-1">{hint}</span>}
  </label>
);

export const Text = ({
  value,
  onChange,
  required,
  type = 'text',
  placeholder,
  readOnly = false,
  inputMode,
}) => (
  <input
    type={type}
    inputMode={inputMode}
    value={value || ''}
    onChange={(e) => onChange(e.target.value)}
    required={required}
    placeholder={placeholder}
    readOnly={readOnly}
    className={`pvs-input w-full${readOnly ? ' opacity-80 cursor-not-allowed' : ''}`}
  />
);

export const Textarea = ({ value, onChange, rows = 3 }) => (
  <textarea
    value={value || ''}
    rows={rows}
    onChange={(e) => onChange(e.target.value)}
    className="pvs-input w-full"
  />
);

export const Select = ({ value, onChange, options, placeholder = 'Select…' }) => (
  <select
    value={value || ''}
    onChange={(e) => onChange(e.target.value)}
    className="pvs-input w-full"
  >
    <option value="">{placeholder}</option>
    {options.map((opt) => (
      <option key={opt.value} value={opt.value}>
        {opt.label}
      </option>
    ))}
  </select>
);

export const Checkbox = ({ label, checked, onChange, disabled = false }) => (
  <label className={`flex items-start gap-2 select-none ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}>
    <input
      type="checkbox"
      checked={Boolean(checked)}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
      className="h-5 w-5 mt-0.5 rounded border-pvs-border bg-transparent accent-pvs-accent disabled:cursor-not-allowed"
    />
    <span className="text-sm text-white">{label}</span>
  </label>
);

export const RadioGroup = ({ name, value, onChange, options }) => (
  <div className="flex flex-wrap gap-3">
    {options.map((opt) => (
      <label key={opt.value} className="flex items-center gap-2 cursor-pointer">
        <input
          type="radio"
          name={name}
          value={opt.value}
          checked={value === opt.value}
          onChange={() => onChange(opt.value)}
          className="h-4 w-4 accent-pvs-accent"
        />
        <span className="text-sm text-white">{opt.label}</span>
      </label>
    ))}
  </div>
);

export const SectionShell = ({ title, description, children }) => (
  <section className="pvs-glass p-6 mb-6">
    <header className="mb-4">
      <h2 className="text-xl font-semibold text-white">{title}</h2>
      {description && <p className="text-sm text-pvs-text-muted mt-1">{description}</p>}
    </header>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{children}</div>
  </section>
);
